/* eslint-disable camelcase */
import { getAuthenticatedRequestInit } from './utils';
import { getApiHost } from '../utils/hosts';

export function JoinRequest(token: string, meeting: number) {
	return fetch(`${getApiHost()}/v2/greenroom/join-request`, {
		method: 'POST',
		body: JSON.stringify({
			meeting,
		}),
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function ApproveJoinRequest(token: string, join_request: number) {
	return fetch(`${getApiHost()}/v2/greenroom/join-request`, {
		method: 'PUT',
		body: JSON.stringify({
			join_request,
		}),
		...getAuthenticatedRequestInit(token),
	}).then((res) => res.ok).catch((error) => {
		console.error(error);
	});
}

export function RejectJoinRequest(token: string, join_request: number) {
	return fetch(`${getApiHost()}/v2/greenroom/join-request`, {
		method: 'DELETE',
		body: JSON.stringify({
			join_request,
		}),
		...getAuthenticatedRequestInit(token),
	}).then((res) => res.ok).catch((error) => {
		console.error(error);
	});
}

export function CheckJoinRequest(token: string, meeting: number) {
	return fetch(`${getApiHost()}/v2/greenroom/join-request/${meeting}`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetActiveRooms(token: string) {
	return fetch(`${getApiHost()}/v2/greenroom/active-rooms`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetIsLive(token: string, meeting: number) {
	return fetch(`${getApiHost()}/v2/greenroom/is-live/${meeting}`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetRequiresApproval(token: string, meeting: number) {
	return fetch(`${getApiHost()}/v2/greenroom/approval-required/${meeting}`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetPendingJoinRequests(token: string, meeting: number) {
	return fetch(`${getApiHost()}/v2/greenroom/join-requests/${meeting}`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function CheckWatcherOnly(token: string, meeting: number) {
	return fetch(`${getApiHost()}/v2/greenroom/watcher-only/${meeting}`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}
